import { render, staticRenderFns } from "./listOrders.vue?vue&type=template&id=5103661f"
import script from "./listOrders.vue?vue&type=script&lang=js"
export * from "./listOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports